/* eslint-disable react/react-in-jsx-scope */
import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import Fiche from "@/project/components/FicheProjet";
import PerformanceDetail from "@/project/components/PerformanceDetail";
import ReportingDetail from "@/project/components/ReportingDetail";
import { Devise, Project as ProjectType } from "@/types/pp";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import Contributions from "./Contributions";
import ProjectDocument from "@/project/components/ProjectDocument";

const Project = () => {
  const { projectId, firstname } = useParams();
  const { data: projectData, loading: loadingProject } =
    useFetchDataV2<ProjectType | null>(
      projectId
        ? `${import.meta.env.VITE_API_ENDPOINT}/project/${projectId}`
        : null,
      `project-${projectId}`,
    );
  const {
    data: devisesData,
    loading: loadingDevises,
    error: errorDevises,
  } = useFetchDataV2<Devise[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/devises`,
    "devises",
  );
  useEffect(() => {
    if (!loadingDevises && !errorDevises && devisesData) {
      localStorage.setItem("devises", JSON.stringify(devisesData));
    }
  }, [devisesData]);
  const { t } = useTranslation("dashboard", {
    keyPrefix: "program",
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "fiche";
  const onTabChange = (value) => {
    setSearchParams({ tab: value, id: projectId });
  };
  if (loadingProject) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <div className="mb-5">
        <ReactBreadcrumb
          items={[
            {
              href: `/${firstname}`,
              name: t("Tableau de bord"),
            },
            {
              href: `/${firstname}/pp/${projectData?.program?.carrier?.id}`,
              name: projectData?.program?.carrier?.firstname || "",
            },
            {
              href: ``,
              name: projectData?.program?.name || "",
            },
          ]}
          isTruncated={false}
        />
        <div className="w-full pt-6">
          <div className="mb-7 mt-3">
            <h1 className="text-2xl font-bold mb-3">{projectData?.name}</h1>
            <p>{projectData?.description}</p>
          </div>

          <Tabs
            defaultValue={tab}
            onValueChange={onTabChange}
            className="w-full"
          >
            <TabsList className="mb-2 grid w-full grid-cols-5 bg-background">
              <TabsTrigger
                className="rounded-none border-b-2 text-[#626262] data-[state=active]:border-foreground data-[state=active]:shadow-none"
                value="fiche"
              >
                {t("Fiche Synthétique")}
              </TabsTrigger>

              <TabsTrigger
                value="financement"
                className="rounded-none border-b-2 text-[#626262] data-[state=active]:border-foreground data-[state=active]:shadow-none"
              >
                {t("Suivi de contributions")}
              </TabsTrigger>
              <TabsTrigger
                value="perf"
                className="rounded-none border-b-2 text-[#626262] data-[state=active]:border-foreground data-[state=active]:shadow-none"
              >
                Suivi des indicateurs
              </TabsTrigger>
              <TabsTrigger
                value="reporting"
                className="rounded-none border-b-2 text-[#626262] data-[state=active]:border-foreground data-[state=active]:shadow-none"
              >
                {t("Reporting")}
              </TabsTrigger>
              <TabsTrigger
                value="document"
                className="rounded-none border-b-2 text-[#626262] data-[state=active]:border-foreground data-[state=active]:shadow-none"
              >
                {t("Documents liés")}
              </TabsTrigger>
            </TabsList>
            {projectData && (
              <TabsContent value="fiche" className="mb-4">
                <Fiche project={projectData} />
              </TabsContent>
            )}
            {projectData && (
              <TabsContent value="financement" className="mb-4">
                {/* <FundingByProject
                  id={projectData.id}
                  projectData={projectData}
                /> */}
                <Contributions id={projectData.id} />
              </TabsContent>
            )}
            {projectData && (
              <TabsContent value="perf" className="mb-4">
                <PerformanceDetail projectData={projectData} />
              </TabsContent>
            )}
            <TabsContent value="reporting" className="mb-4">
              <ReportingDetail projectData={projectData} />
            </TabsContent>
            <TabsContent value="document" className="mb-4">
              <ProjectDocument />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Project;
